import FulfillmentQueue from './FulfillmentQueue';
export default function FulfillmentPTO() {
  return <FulfillmentQueue title="PTO" statusFilter="pto" emptyMessage="No PTO orders" />;
}
